module.exports = __webpack_public_path__ + "static/media/2 (52).b3fd9e73.jpg";